import axios from 'axios';
import VisibilityIcon from '../../assets/Icons/visibility-icon';
import TrashIcon from '../../assets/Icons/trash';
import { useAppSelector } from '../../store/hooks';

type Props = {
  openRequiredDocumentDeleteModal: (reqDocId: string) => void;
  handleDocumentDelete?: (documentId: string) => void;
};

export const useStrategyActions = ({
  openRequiredDocumentDeleteModal,
  handleDocumentDelete,
}: Props) => {
  const userState = useAppSelector(state => state.user);

  const isAdmin = userState.user?.role !== 'user';
  const isClientView = userState.user?.role !== 'user' && !!userState.client;

  const handleDownload = (doc: any) => {
    const url = new URL(doc?.src!);
    const file = url.pathname.split('/').pop();
    const filename = file!.split('.')[0];

    const link = document.createElement('a');

    axios
      .get(doc.src!, {
        responseType: 'blob',
      })
      .then(res => {
        link.href = URL.createObjectURL(res.data);
        link.download = filename;
        link.click();
      })
      .finally(() => {
        link.remove();
      });
  };

  const uploadDocumentActions = (requiredDoc: any) => {
    const actions = [
      {
        icon: <TrashIcon />,
        text: 'Remove required document',
        onClick: () => openRequiredDocumentDeleteModal(requiredDoc.id),
      },
    ];

    return isAdmin && !isClientView && !requiredDoc.global
      ? actions
      : undefined;
  };

  const documentActions = (requiredDoc: any) => {
    const actions: any = [
      {
        icon: <VisibilityIcon />,
        text: 'Display document',
        onClick: () => window.open(requiredDoc.document.src),
      },
    ];

    if (isAdmin && !isClientView && !requiredDoc.global) {
      actions.push({
        icon: <TrashIcon />,
        text: 'Remove required document',
        onClick: () => openRequiredDocumentDeleteModal(requiredDoc.id),
      });
    } else if (!isAdmin) {
      actions.push({
        icon: <TrashIcon />,
        text: 'Remove document',
        onClick: () => handleDocumentDelete!(requiredDoc.document.id),
      });
    }

    return actions;
  };

  return { handleDownload, uploadDocumentActions, documentActions };
};
